import {
  makeEnvironmentProviders,
  type EnvironmentProviders,
} from '@angular/core';
import { defaultsDeep } from 'lodash-es';
import { type PartialDeep } from 'type-fest';

import { type INavbarConfig } from './navbar.interfaces';
import {
  NAVBAR_CONFIG,
  NAVBAR_USER_CONFIG,
  NavbarConfig,
} from './providers/navbar-config';

function userConfigFactory(
  userConfig: PartialDeep<INavbarConfig>,
): NavbarConfig {
  return defaultsDeep(userConfig, new NavbarConfig());
}

export function provideNavbarConfig(
  config: Partial<INavbarConfig> = {},
): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: NAVBAR_USER_CONFIG,
      useValue: config,
    },
    {
      provide: NAVBAR_CONFIG,
      useFactory: userConfigFactory,
      deps: [NAVBAR_USER_CONFIG],
    },
  ]);
}
